import { UserDocOld } from '@contracts/platform';
import { CollectionMap, CollectionOf } from '@contracts/shared';
import { makeUseDocumentPath } from '../store-tools';

type CommonCollections = CollectionMap<{
	users: CollectionOf<'uid', UserDocOld>;
}>;

export const useDocumentPath = makeUseDocumentPath<CommonCollections>();
